import * as React from "react";

export interface DrawerContextValue {
  isDrawerOpen: boolean;
  drawerSize: number;
}

const DrawerContext = React.createContext<DrawerContextValue>({
  isDrawerOpen: false,
  drawerSize: 0
});

export const useDrawerContext = () => React.useContext(DrawerContext);

export const DrawerProvider: React.FC<{ children: React.ReactNode; value: DrawerContextValue }> = ({
  children,
  value
}) => {
  return <DrawerContext.Provider value={value}>{children}</DrawerContext.Provider>;
};
